export default __webpack_public_path__ + "static/media/HUM.5c70c960.svg";